import { render, staticRenderFns } from "./openstreetmap.vue?vue&type=template&id=f5343f26&"
import script from "./openstreetmap.vue?vue&type=script&lang=js&"
export * from "./openstreetmap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f5343f26')) {
      api.createRecord('f5343f26', component.options)
    } else {
      api.reload('f5343f26', component.options)
    }
    module.hot.accept("./openstreetmap.vue?vue&type=template&id=f5343f26&", function () {
      api.rerender('f5343f26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4d5rGp3zSNg4x/JS/comp/openstreetmap.vue"
export default component.exports